module.exports = "<div class=\"pageContent classicArea withNav\">\n  <navbar></navbar>\n  <div class=\"limitContent\">\n    <rlink-apps-status></rlink-apps-status>\n    <section class=\"rlinkManage\">\n      <h2>\n        {{ 'manageMyRlink.title' | translate }}\n      </h2>\n      <div class=\"tabAppCarto\">\n        <div id=\"panelApps\" class=\"tabApp tabClassic card\">\n          <manage-my-rlink-categories></manage-my-rlink-categories>\n          <ui-view />\n        </div>\n      </div>\n      <help-block></help-block>\n    </section>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vehicle/manage-my-rlink/manage-my-rlink.html
// module id = 1114
// module chunks = 0